query getAllCompetitions(
  $first: Int,
  $offset: Int,
  $filter: CompetitionFilter,
  ) {
    competitions: allCompetitions(
    filter: $filter
    first: $first
    offset: $offset
    orderBy: COMPETITION_NAME_ASC

    ) {
      nodes {
        competitionId
        competitionName
        region {
          regionId
          regionName
        }
        sport {
          sportId
          sportName
        }
        core: subscribedCompetitionsByCompetitionId {
          totalCount
          nodes {
            isOfferedLive
            isOfferedPreMatch
          }
        }
        sameGameParlays: sgpSubscribedCompetitionsByCompetitionId {
          totalCount
        }
        playerProps: playerPropsSubscribedCompetitionsByCompetitionId {
          totalCount
        }
        micro: microSubscribedCompetitionsByCompetitionId {
          totalCount
        }
        mappings: competitionMappingsByIntId {
          nodes {
            mappingType
          }
        }
        competitionFavoritesByCompetitionId {
            nodes {
            competition {
                competitionName
                competitionId
                    }
                }
            }
      }
      totalCount
    }
}
